import { SET_ORGANIZATION } from './types';


export const setOrganization = (param: any) => async (dispatch: any) => {
    dispatch({
        type: SET_ORGANIZATION,
        payload: param
    })
}